import React from 'react'
import { object, bool } from 'prop-types'
import { css } from '@emotion/react'
import { Link } from 'gatsby'
import ArrowIcon from '../../assets/icons/arrow_forward.inline.svg'

const itemCss = (theme) => css`
  display: flex;
  align-items: center;
  margin: 0;
  color: ${theme.colors.gray600};
  flex-shrink: 0;
  min-width: 0;
`

const styledLinkCss = (theme) => css`
  display: block;
  text-decoration: none;
  color: ${theme.colors.gray600};

  > svg > path {
    fill: ${theme.colors.gray600};
  }
`

const styledArrowIconCss = (theme) => css`
  width: 10px;
  height: 10px;
  fill: ${theme.colors.gray600};
  margin: 0 10px;
`

const Breadcrumb = ({ item, includeIcon = true, ...rest }) => {
  return (
    <li css={itemCss} {...rest}>
      {item.path ? (
        <Link css={styledLinkCss} to={item.path}>
          {item.title}
        </Link>
      ) : (
        <p>{item.title}</p>
      )}
      {includeIcon && <ArrowIcon css={styledArrowIconCss} />}
    </li>
  )
}

Breadcrumb.propTypes = {
  item: object,
  includeIcon: bool,
}

export default Breadcrumb
